import React, { useState } from 'react';
import { apiUrl, authFetch, authHeaders } from './config/apiClient';
import AvButton from './design/nedi/AvButton';

const toOptionalNumber = (value) => (value === '' ? null : Number(value));

export default function ManualEntryEditor({ entry, onClose, onSaved }) {
  const [entryDate, setEntryDate] = useState(entry.entry_date || '');
  const [manualType, setManualType] = useState(entry.manual_type || 'diary');
  const [title, setTitle] = useState(entry.note_title || '');
  const [note, setNote] = useState(entry.note || '');
  const [mood, setMood] = useState(entry.mood || 'good');
  const [latitude, setLatitude] = useState(entry.latitude ?? '');
  const [longitude, setLongitude] = useState(entry.longitude ?? '');
  const [status, setStatus] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!entryDate || !note.trim()) {
      setStatus('Data e nota são obrigatórias.');
      return;
    }

    setSaving(true);
    setStatus('');
    try {
      const response = await authFetch(apiUrl(`/api/manual-entry/${entry.id}`), {
        method: 'PATCH',
        headers: {
          ...authHeaders(),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          entry_date: entryDate,
          note_title: title.trim() || null,
          note: note.trim(),
          mood: mood || null,
          latitude: toOptionalNumber(latitude),
          longitude: toOptionalNumber(longitude),
          manual_type: manualType,
        }),
      });
      const result = await response.json();
      if (!response.ok) {
        setStatus(result.error || 'Não foi possível atualizar a entrada.');
        return;
      }
      await onSaved();
    } catch {
      setStatus('Não foi possível conectar ao servidor para atualizar a entrada.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="diary-modal-overlay" onClick={onClose}>
      <div className="diary-modal-content glass-panel" onClick={(event) => event.stopPropagation()}>
        <button type="button" className="diary-modal-close" onClick={onClose} aria-label="Fechar">×</button>
        <h3 className="diary-modal-title">Editar entrada manual</h3>
        <form onSubmit={handleSubmit}>
          <label className="manual-entry-editor-field">
            Data
            <input type="date" value={entryDate} onChange={(event) => setEntryDate(event.target.value)} required />
          </label>
          <label className="manual-entry-editor-field">
            Tipo
            <select value={manualType} onChange={(event) => setManualType(event.target.value)}>
              <option value="diary">Diário</option>
              <option value="checkin">Check-in</option>
              <option value="milestone">Marco</option>
            </select>
          </label>
          <label className="manual-entry-editor-field">
            Título (opcional)
            <input value={title} onChange={(event) => setTitle(event.target.value)} />
          </label>
          <label className="manual-entry-editor-field">
            Nota
            <textarea value={note} onChange={(event) => setNote(event.target.value)} rows={4} required />
          </label>
          {manualType === 'diary' && (
            <label className="manual-entry-editor-field">
              Humor
              <select value={mood} onChange={(event) => setMood(event.target.value)}>
                <option value="good">Bom</option>
                <option value="ok">Neutro</option>
                <option value="bad">Ruim</option>
              </select>
            </label>
          )}
          <div className="manual-entry-editor-coordinates">
            <label className="manual-entry-editor-field">
              Latitude (opcional)
              <input type="number" step="any" value={latitude} onChange={(event) => setLatitude(event.target.value)} />
            </label>
            <label className="manual-entry-editor-field">
              Longitude (opcional)
              <input type="number" step="any" value={longitude} onChange={(event) => setLongitude(event.target.value)} />
            </label>
          </div>
          {status && <p className="manual-entry-editor-status" role="alert">{status}</p>}
          <div className="manual-entry-editor-actions">
            <AvButton type="submit" variant="primary" disabled={saving}>
              {saving ? 'Salvando…' : 'Salvar alterações'}
            </AvButton>
            <AvButton type="button" variant="secondary" onClick={onClose} disabled={saving}>
              Cancelar
            </AvButton>
          </div>
        </form>
      </div>
    </div>
  );
}
